import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/dashboard/_layout/')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  beforeLoad: ({ location }) => {
    throw redirect({
      to: '/dashboard/workflows',
      hash: location.hash.replace(/^#/, '') || undefined,
    });
  },
});

function RouteComponent() {
  return null;
}
